module.exports = __webpack_public_path__ + "img/gpkmega_packs.topps.a8d5d86.png";